<template>
  <v-layout>
    <v-dialog v-bind:value="dialog" @click:outside="close" max-width="1200px">
      <v-card class="background-voucher" style="background: rgb(221, 225, 230)">
        <v-form v-on:submit.prevent="createItem">
          <v-card-title class="mb-4">
            <span class="headline">{{modal_title}}</span>
          </v-card-title>
          <v-card-text>
            <div class="row">
              <div class="col-md-12">
                <DatosGenerales :item="item" :isViewModal="isViewModal()" :open="dialog" :validator="$validator" />
                
                <ConStock :invoice="item" :validator="$validator" :open="dialog" :isViewModal="isViewModal()" />

                <Items :inventory_operation="item" :open="dialog" :validator="$validator" :isViewModal="isViewModal()" />

                <Observation :item="item" :isViewModal="isViewModal()" />
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="close()">Cerrar</v-btn>
            <v-btn color="success" v-if="!isViewModal()" text type="submit" :loading="loading">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";
import { inventoryOperationService } from "@/libs/ws/inventoryOperationService";

import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";

import DatosGenerales from "@/views/InventoryOperation/InventoryOperationComponent/DatosGenerales.vue";
import Items from "@/views/InventoryOperation/InventoryOperationComponent/Items.vue";
import Observation from "@/components/Comprobantes/Observation.vue";
import ConStock from "@/components/Comprobantes/ConStock.vue";

export default {
  mixins: [ModalGenericMixin],
  components: { DatosGenerales, Items, Observation, ConStock },
  props: {
    inventory_operation: { type: Object, default: null },
    dialog: Boolean,
    button_name: String,
    formBtn: String,
    closeDialog: Function,
    modal_title: String
  },
  data() {
    return {
      show: false,
      formatUtils: formatUtils,
      total: 0,
      defaultItem: null,
      item: {
        id: 0,
        warehouse: null,
        op_type: null,
        document_type: null,
        external_reference: null,
        observations: null,
        items: [],
      },
     
    };
  },
  created: function () {
    window.addEventListener("keydown", (e) => {
      if (e.key == "Escape") {
        this.close();
      }
    });
  },
  watch: {
    dialog(val) {
      this.$validator.reset();
      this.errors.clear();
    },
    inventory_operation: {
      handler: function (val) {
        this.init();
      },
      deep: true,
    },
   
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.item));
    this.init();
  },
  methods: {
    
    close() {
      this.item = JSON.parse(JSON.stringify(this.defaultItem));
      this.$emit("updateDialog",false);
    },
    init() {
      this.item = this.inventory_operation;
    },
    customValidations() {
      /*
      if (this.total > this.item.spent.pending_to_paid) {
        this.$toast.error("El importe total del pago no puede ser mayor que el del gasto.", "Error");
        return false;
      }
      */
      return true;
    },
  
    createItem(e) {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          e.preventDefault();

          if (!this.customValidations()) {
            return;
          }

          this.loading = true;

          let data = JSON.parse(JSON.stringify(this.item));
          data.items_arr = data.items;
          data.op_type = data.op_type.id;
          data.stock_type = data.stock_type.id;
          delete data.items; //Para que no sobreescriba          

            inventoryOperationService
              .create(data)
              .then((response) => {
                if (response.status) {
                  this.$toast.success("La operacion de inventario se creo correctamente", "OK");
                  this.close();
                  this.$emit("reload");
                } else {
                  if (Object.prototype.hasOwnProperty.call(response, "message")) {
                    this.$toast.error(response.message, "Error");
                  } else {
                    this.$toast.error(response.msg, "Error");
                  }
                }
              })
              .catch((e) => {
                console.log(e);
                //this.$toast.error(response.msg, "Error");
              })
              .finally(() => (this.loading = false));
          }
        
      });
    },
    isViewModal() {
      return this.formBtn == "";
    },
  },
};
</script>
